"use client";

import { useEffect } from "react";

export function TimezoneProvider() {
  useEffect(() => {
    // 사용자의 timezone 감지
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // 쿠키에 저장 (1년 유효)
    document.cookie = `user_timezone=${timeZone}; path=/; max-age=31536000; SameSite=Lax`;
  }, []);

  return null;
}
